<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Stranice</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Stranice</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <!--<v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="selectedItem.name"
                            dense
                            label="Naziv"
                            outlined
                    ></v-text-field>
                </v-col>-->
                <v-col cols="12" sm="6" class="px-2">
                    <v-select clearable
                            :items="pages"
                            v-model="selectedItem.parent"
                            dense
                            label="Roditelj"
                            outlined
                            return-object
                            item-value="id"
                            item-text="name"
                    ></v-select>
                </v-col>

                <v-col cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="px-2 mt-4">


                    <v-tabs v-model="tab" background-color="primary" dark height="40">
                        <v-tab v-for="item in selectedItem.langs" :key="item.tab">
                            {{ item.lang.name }}
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in selectedItem.langs" :key="item.tab">
                            <v-card>
                                <v-card-text>
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="6" class="px-2">
                                            <v-text-field
                                                    v-model="item.title"
                                                    dense
                                                    label="Naziv"
                                                    outlined
                                                    @input="seo(item)"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" class="px-2">
                                            <v-text-field
                                                    v-model="item.seo_url"
                                                    dense
                                                    label="Seo url"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-text-field
                                                    v-model="item.meta_description"
                                                    dense
                                                    label="Meta opis"
                                                    outlined
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" class="px-2">
                                            <v-combobox
                                                    v-model="item.keywords"
                                                    dense
                                                    outlined
                                                    label="Kljucne reci"
                                                    multiple
                                                    small-chips
                                            ></v-combobox>
                                        </v-col>
                                        <v-col cols="12" class="px-2">
                                            <span>Introtext</span>
                                            <ckeditor v-model="item.introtext" :config="editorConfig"></ckeditor>
                                        </v-col>

                                        <v-col cols="12" class="px-2">
                                            <span>Content</span>
                                            <ckeditor v-model="item.content" :config="editorConfig"></ckeditor>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>


                </v-col>
                <v-col cols="12" class="mt-2">
                    <v-row justify="center">
                        <v-btn color="primary" tile depressed @click="save">Snimi</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
	import bitPage from "../../components/layout/page";
	//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

	export default {
		components: {
			bitPage
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Stranice',
					disabled: false,
					to: {name: 'stranice'},
				},
				{
					text: 'Dodavanje nove stranice',
					disabled: true
				},
			],
			items: [],
			date: new Date().toISOString().substr(0, 10),
			date2: new Date().toISOString().substr(0, 10),
			menu: false,
			modal: false,
			menu2: false,
			//editor: ClassicEditor,
			editorData: '<p>Rich-text editor content.</p>',
			editorConfig: {
                extraPlugins: 'justify'
			},
            tab: null,
            pages: [],
            selectedItem: {
                name: null,
                parent_id: null,
                langs: []
            }
		}),
        created() {
            if(this.$route.params.item){
                this.selectedItem = this.$route.params.item;
                this.getLangs();
                this.selectedItem.langs.forEach(lang => {
                    return lang.keywords = lang.keywords && lang.keywords.split(',')
                        ? lang.keywords.split(',') : []
                })
            }
            else{
                this.getLangs();
            }
            this.getPages();
        },
        methods: {
            getPages() {
                this.pages = [];
                this.axios.get(`/page`)
                    .then(res => {
                        console.log(res)
                        res.data.forEach(item => {
                            let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                            item['name'] = lang && lang.title ? lang.title : '';
                            if (item['name'] !== '') this.pages.push(item)
                        })
                    }).then(() => {
                        console.log('aaaa', this.pages)
                    })
            },
            getLangs() {
                this.$store.dispatch('GET_LANGUAGES').then(res => {
                    res.forEach(lang => {
                        let check = this.selectedItem.langs.find(item => item.lang_id === lang.id)
                        if(!check) {
                            this.selectedItem.langs.push({
                                title: null,
                                seo_url: null,
                                meta_description: null,
                                keywords: null,
                                short_description: null,
                                description: null,
                                lang: lang,
                                lang_id: lang.id
                            })
                        }
                    })

                    console.log(this.selectedItem)
                })
            },
            save() {
                this.selectedItem.parent_id = this.selectedItem.parent ? this.selectedItem.parent.id : null

                if(this.$route.params.item && !this.$route.params.sub){
                    this.axios.put(`/page/${this.$route.params.item.id}`, this.selectedItem).then(res => {
                        this.$router.push({name: 'stranice'})
                    })
                }
                else{
                    this.selectedItem.type = this.$route.params.type

                    this.axios.post(`/page`, this.selectedItem).then(res => {
                        this.$router.push({name: 'stranice'})
                    })
                }
            },
            seo(item) {
                item.seo_url = item.title.toLowerCase()
                    .replace(/ /g,'-')
                    .replace(/[^\w-]+/g,'')
            }
        },
        computed: {
            setLang() {
                return this.$store.state.lang.code === 'en'
                    ? 'en' : this.$store.state.lang.code === 'la'
                        ? 'sr' : 'ћи'
            }
        },
	}
</script>
